module.exports = __webpack_public_path__ + "static/media/galerija_2019 (30).c5658ae8.jpg";